<template>
	<div class="Toolbar">
		<div class="Toolbar-wrapper">
			<div class="Toolbar-pageControls">
				<button type="button" class="btn btn-warning" @click="prevPage()">
					<span class="hidden-xs hidden-sm">Prev</span>
					<span class="visible-xs visible-sm"><i class="fa fa-arrow-left"></i></span>
				</button>
				<button type="button" class="btn btn-warning" @click="nextPage()">
					<span class="hidden-xs hidden-sm">Next</span>
					<span class="visible-xs visible-sm"><i class="fa fa-arrow-right"></i></span>
				</button>
				<!--
                            <input type="text" class="form-control" v-model="page">
                            <span> of {{pageCount}} pages </span>
                            <button type="button" class="btn btn-primary" @click="goToPage()">Go</button>
                -->
				<span class="hidden-xs">
				<button type="button" class="btn btn-primary" style="margin-left:20px" @click="showInks()">Inks</button>
				<button type="button" class="btn btn-primary" @click="showOverview()">Overview</button>
				<button type="button" class="btn btn-primary" @click="showOverprint()">Overprint</button>
				<button type="button" class="btn btn-primary" @click="toggleBoxes()">Boxes</button>
				<button type="button" class="btn btn-primary" @click="toggleRulers()">Rulers</button>

				<div class="btn-group">
					<button type="button" class="btn btn-danger" @click="setUnits('mm')">mm</button>
					<button type="button" class="btn btn-danger" @click="setUnits('inch')">inch</button>
				</div>
			</span>
			</div>
			<div class="Toolbar-zoomControls">
				<button type="button" class="btn btn-primary" @click="zoomIn()"><i class="fa fa-plus"></i></button>
				<input type="text" class="form-control" style="width:60px" v-model="zoomLevel" disabled>
				<button type="button" class="btn btn-primary" @click="zoomOut()"><i class="fa fa-minus"></i></button>
				<div class="btn-group">
					<button type="button" class="btn btn-primary" @click="fitTo('page')">Fit to page</button>
					<button type="button" class="btn btn-primary" @click="fitTo('width')">Fit to width</button>
				</div>
			</div>

			<div class="Toolbar-mobileToggle">
				<button type="button" class="btn btn-default" @click="handleMobileToggleBtnClick">
					<i class="fa fa-caret-down" v-if="!isMobileAdvancedMenuOpen"></i>
					<i class="fa fa-times" v-if="isMobileAdvancedMenuOpen"></i>
				</button>
			</div>
		</div>
		<div class="Toolbar-mobileAdvanced" v-if="isMobileAdvancedMenuOpen">
			<button type="button" class="btn btn-primary" @click="showInks()">Inks</button>
			<button type="button" class="btn btn-primary" @click="showOverview()">Overview</button>

			<div class="btn-group">
				<button type="button" class="btn btn-danger" @click="setUnits('mm')">mm</button>
				<button type="button" class="btn btn-danger" @click="setUnits('inch')">inch</button>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		props: [
			// "pageCount",
			"page",
			"zoomLevel",
			"zoomIn",
			"zoomOut",
			"fitTo",
			"prevPage",
			"nextPage",
			"showInks",
			"showOverview",
			"toggleBoxes",
			"toggleRulers",
			"setUnits",
			"showOverprint"
		],
		data() {
			return {
				pageCount: 0,
				isMobileAdvancedMenuOpen: false
			}
		},
		methods: {
			handleMobileToggleBtnClick(){
				this.isMobileAdvancedMenuOpen = !this.isMobileAdvancedMenuOpen;
			}
		}
	}
</script>
<style lang="css">
	@import "~leaflet/dist/leaflet.css";

	.Toolbar {
		flex-shrink: 1;
		margin-bottom: 20px;
	}

	.Toolbar-wrapper {
		display: flex;
		justify-content: space-between;
	}

	.Toolbar input {
		display: inline-block;
		max-width: 100px !important;
	}

	.Toolbar-mobileAdvanced {
		margin-top: 5px;
	}

	@media (max-width: 767px) {
		.Toolbar {
			margin-bottom: 5px;
			padding: 0 15px;
		}

		.Toolbar-pageControls,
		.Toolbar-zoomControls {

		}
	}
</style>



// WEBPACK FOOTER //
// Toolbar.vue?5a0500dc